import { render, staticRenderFns } from "./BottomArea.vue?vue&type=template&id=3c1525c1&scoped=true&"
import script from "./BottomArea.vue?vue&type=script&lang=js&"
export * from "./BottomArea.vue?vue&type=script&lang=js&"
import style0 from "./BottomArea.vue?vue&type=style&index=0&id=3c1525c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1525c1",
  null
  
)

export default component.exports